<template>
  <div class="users-page flex flex-col h-full">
    <div class="users-page__header flex-shrink-0">
      <div class="users-page__title-row">
        <h1 class="users-page__title">Пользователи</h1>
        <span class="users-page__count">{{ users.length }}</span>
      </div>
      <div class="users-page__filters">
        <div class="flex flex-wrap items-center gap-3">
          <el-select
            v-model="filters.type"
            @change="getUsers"
            placeholder="Статус"
            clearable
            filterable
            style="max-width: 200px"
          >
            <el-option
              v-for="opt in statusOptions"
              :key="opt.value"
              :label="opt.label"
              :value="opt.value"
            />
          </el-select>
          <el-select
            v-model="filters.typeAccount"
            @change="getUsers"
            placeholder="Тип аккаунта"
            clearable
            filterable
            style="max-width: 200px"
          >
            <el-option
              v-for="opt in accountTypeOptions"
              :key="opt.value"
              :label="opt.label"
              :value="opt.value"
            />
          </el-select>
          <el-input
            v-model="filters.search"
            @change="getUsers"
            placeholder="Имя, фамилия или email"
            clearable
            style="max-width: 200px"
          ></el-input>
          <el-button type="primary" plain @click="createUser">
            Создать
          </el-button>
        </div>
      </div>
    </div>
    <main
      class="users-page__body flex-1 min-h-0 flex flex-col overflow-hidden"
      style="padding: 20px 26px"
    >
      <div class="flex-1 min-h-0 flex flex-col">
        <SkeletonView
          v-if="loading"
          :column="17"
          :row="12"
          size-table="large"
        />
        <el-table
          v-else
          border
          stripe
          class="h-full"
          height="100%"
          style="overflow-y: auto; height: 100%"
          @row-click="viewUser"
          :data="users"
          :row-class-name="tableRowClassName"
        >
          <el-table-column
            type="index"
            label="N"
            width="60"
            align="center"
          ></el-table-column>
          <el-table-column prop="first_name" label="Имя"></el-table-column>
          <el-table-column prop="last_name" label="Фамилия"></el-table-column>
          <el-table-column prop="email" label="Email"></el-table-column>
          <el-table-column prop="roles" label="Роли"></el-table-column>
          <el-table-column label="Действия" align="center">
            <template v-slot="scope">
              <el-button
                circle
                @click.stop.prevent="changePasswordUser(scope.row._id)"
              >
                <svg
                  class="ov-icon"
                  aria-hidden="true"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  style="color: var(--muted-foreground)"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                  ></path>
                </svg>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </main>
    <el-dialog
      v-model="passwordChangeShow"
      title="Заменить пароль"
      width="600px"
    >
      <el-form label-position="top">
        <el-form-item label="Введите пароль">
          <el-input type="password" show-password v-model="form.password">
          </el-input>
        </el-form-item>
        <el-form-item label="Повторите пароль">
          <el-input
            v-model="form.confirmPassword"
            show-password
            type="password"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div class="mt-3 text-right">
        <el-button
          :disabled="
            form.password &&
            form.confirmPassword &&
            form.password !== form.confirmPassword
          "
          @click="updatePassword"
          type="primary"
          >Поменять пароль</el-button
        >
      </div>
    </el-dialog>
    <router-view @refetch-users="getUsers"></router-view>
  </div>
</template>

<script>
import { changeUserPassword, getUsers } from "@/api/users";
import SkeletonView from "@/components/skeleton/SkeletonView.vue";
export default {
  components: {
    SkeletonView,
  },
  data() {
    return {
      users: [],
      loading: false,
      form: {
        id: null,
        password: null,
        confirmPassword: null,
      },
      filters: {
        type: null,
        typeAccount: null,
        search: "",
      },
      debounce: null,
      showingInputs: {
        password: false,
        confirmPassword: false,
      },
      passwordChangeShow: false,
    };
  },
  computed: {
    userId() {
      return this.$route.params.userId;
    },
    user() {
      return this.users.find((u) => u._id === this.userId);
    },
    statusOptions() {
      return [
        { label: "Действующие", value: 1 },
        { label: "Удаленные", value: -1 },
      ];
    },
    accountTypeOptions() {
      return [
        { label: "Верификатор", value: "verifier" },
        { label: "Разметчик", value: "annotator" },
        { label: "Админ", value: "admin" },
      ];
    },
  },
  async created() {
    if (this.$route.query.search) {
      this.filters.search = String(this.$route.query.search);
    }
    await this.getUsers();
  },
  methods: {
    async getUsers() {
      let filters = this.getFilters();
      this.loading = true;
      try {
        this.users = await getUsers(filters);
      } catch (e) {
        this.users = [];
      } finally {
        this.loading = false;
      }
    },
    getFilters() {
      let params = {};
      if (this.filters.typeAccount) {
        params.role = this.filters.typeAccount;
      }
      if (this.filters.type) {
        params.status = this.filters.type;
      }
      if (this.filters.search) {
        params.search = this.filters.search;
      }
      return params;
    },
    viewUser(row) {
      this.$router.push({ name: "user-view", params: { userId: row._id } });
    },
    createUser() {
      this.$router.push({ name: "user-view", params: { userId: "new" } });
    },
    tableRowClassName({ row }) {
      if (row.status === -1) {
        return "warning-row";
      }
      return "";
    },
    changePasswordUser(id) {
      console.log(id);
      this.passwordChangeShow = true;
      this.form.id = id;
    },
    async updatePassword() {
      let data = await changeUserPassword(this.form.id, this.form.password);
      if (data._success) {
        this.passwordChangeShow = false;
        this.form.id = null;
        this.form.password = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/* Mount fade */
.users-page {
  animation: users-fade-in 0.3s cubic-bezier(0.22, 1, 0.36, 1) both;
}
@keyframes users-fade-in {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ===== Taskk-style header ===== */
.users-page__header {
  padding: 10px 26px 0;
}
.users-page__title-row {
  display: flex;
  align-items: center;
  gap: 12px;
}
.users-page__title {
  margin: 0;
  font-size: 30px;
  font-weight: 800;
  letter-spacing: -0.8px;
  color: var(--foreground);
  line-height: 1.1;
}
.users-page__count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 26px;
  padding: 0 9px;
  border-radius: 999px;
  background: var(--muted);
  border: 1px solid var(--border);
  color: var(--muted-foreground);
  font-size: 13px;
  font-weight: 600;
}
.users-page__filters {
  margin-top: 18px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--border);

  // shadcn fields
  ::v-deep(.el-input__wrapper) {
    height: 38px;
    border-radius: 9px;
    background: var(--card);
    box-shadow: 0 0 0 1px var(--input) inset;
    padding: 1px 12px;
    transition: box-shadow 0.18s ease, background-color 0.18s ease;
    &:hover {
      box-shadow: 0 0 0 1px var(--border-strong) inset;
    }
    &.is-focus {
      box-shadow: 0 0 0 1px var(--border-strong) inset, 0 0 0 3px var(--ring);
    }
  }
  ::v-deep(.el-input__inner) {
    color: var(--foreground);
    font-size: 13px;
    font-weight: 500;
    &::placeholder {
      color: var(--muted-foreground);
    }
  }
  ::v-deep(.el-select__caret),
  ::v-deep(.el-input__icon) {
    color: var(--muted-foreground);
  }
  // primary "Создать" → solid token button
  ::v-deep(.el-button--primary) {
    height: 38px;
    border-radius: 9px;
    background: var(--primary);
    border-color: var(--primary);
    color: var(--primary-foreground);
    font-size: 13px !important;
    font-weight: 500 !important;
    &:hover {
      opacity: 0.9;
      background: var(--primary);
      border-color: var(--primary);
      color: var(--primary-foreground);
    }
  }
}

/* ===== Table ===== */
.el-table .bg-blue-50 {
  background: rgba(59, 130, 246, 0.12);
}
::v-deep(.el-table__header th.el-table__cell) {
  background: var(--muted);
  color: var(--muted-foreground);
  font-weight: 500;
  font-size: 12px;
}
.users-page__body ::v-deep(.el-table) {
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid var(--border);
  &::before,
  &::after {
    display: none;
  }
  .el-table__inner-wrapper::before,
  .el-table__border-left-patch {
    display: none;
  }
}

// action lock button — neutral, theme-aware
.users-page__body ::v-deep(.el-button.is-circle) {
  background: var(--card);
  border: 1px solid var(--border);
  &:hover {
    background: var(--accent);
    border-color: var(--border-strong);
  }
}
</style>
